import { render, staticRenderFns } from "./WidgetConfigurationTable.vue?vue&type=template&id=f500596a&"
import script from "./WidgetConfigurationTable.vue?vue&type=script&lang=js&"
export * from "./WidgetConfigurationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports